






























import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import allTrain from "@/views/train/allTrain.vue";
import myTrain from "@/views/train/myTrain.vue";
import util from "@/lib/util";
import ShortHeaderLayout from "@/layouts/shortHeaderLayout.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import DescriptionList from "@/components/DescriptionList/DescriptionList.vue";
import DescriptionListItem from "@/components/DescriptionList/DescriptionListItem.vue";
import SectionLayout from "@/layouts/sectionLayout.vue";
import AppConsts, {EMPTY_OBJECT} from "@/lib/appconst";

const NAVGAITE_TYPE = {
    START_POINT: 1,
    END_POINT: 2
}

@Component({
    components: {SectionLayout, ShortHeaderLayout, basicPage, DescriptionList, DescriptionListItem}
})
export default class trainMap extends basicPage {
    @Prop({}) data: any;
    // @Prop({type:String,default:'102.736957,25.053908'}) coord:string;

    placeholder: string = '输入起点';
    inputLocation: string = '';
    posType = 1;
    coord:string;

    initMap() {
        // let coords = this.coord.split(",");
        let BMap: any = window['BMap'];
        var map = new BMap.Map("map");
        let localSearch = new BMap.LocalSearch(map);
        localSearch.setSearchCompleteCallback((e) => {
            var poi = e.getPoi(0)
            if (poi) {
                var point = poi.point;
                this.coord = `${point.lng},${point.lat}`;
                map.centerAndZoom(point, 20);
                var marker = new BMap.Marker(point); // 创建标注
                map.addOverlay(marker);             // 将标注添加到地图中
                marker.disableDragging();           // 不可拖拽
            }
        })
        localSearch.search(this.data.meetingAdress);
    }

    operChange(e) {
        let arr = {
            1: '输入起点',
            2: '输入终点'
        }
        this.placeholder = arr[e];
        this.posType = e;
    }

    mounted() {
        this.initMap();
    }

    navigate(type) {
        let coords = this.coord.split(",");
        let url = '';

        let typeArr = {
            0: 'transit',
            1: 'driving'
        }
        let walkType = typeArr[type];

        if (this.posType == NAVGAITE_TYPE.START_POINT) {
            url = `http://api.map.baidu.com/direction?origin=${this.inputLocation}&destination=${coords[1]},${coords[0]}&region=昆明&mode=${walkType}&output=html&src=webapp.baidu.openAPIdemo`;
        } else {
            url = `http://api.map.baidu.com/direction?destination=${this.inputLocation}&origin=${coords[1]},${coords[0]}&region=昆明&mode=${walkType}&output=html&src=webapp.baidu.openAPIdemo`;
        }
        window.open(url);
    }

}
